/*
Author: Nishant Singh
*/

import { Cart } from '~api/cart';
import { createAsyncThunk } from '@reduxjs/toolkit';
import AsyncStorage from '@react-native-async-storage/async-storage';

// ...........Actions creator
export const SET_VOUCHER = 'SET_VOUCHER';
export const RESET_VOUCHER = 'RESET_VOUCHER';
export const SET_SELECT_VOUCHER = 'SET_SELECT_VOUCHER';
export const SET_SELECT_PAYMENT_PROMO = 'SET_SELECT_PAYMENT_PROMO';

// ..........actions
export const applyVoucher = createAsyncThunk(
  SET_VOUCHER,
  async (payload, thunkAPI) => {
    const cartDetail = thunkAPI.getState().cart.cartDetail;
    const UNSELECTED_PRODUCTS_KEY = 'unselected_products_cache';

    try {
      if (cartDetail?.unselected_products?.length > 0) {
        try {
          const existingData = await AsyncStorage.getItem(
            UNSELECTED_PRODUCTS_KEY,
          );
          const existingUnselectedProducts = existingData
            ? JSON.parse(existingData)
            : {};

          const cartId = cartDetail._id || 'default_cart';

          existingUnselectedProducts[cartId] = cartDetail.unselected_products;

          await AsyncStorage.setItem(
            UNSELECTED_PRODUCTS_KEY,
            JSON.stringify(existingUnselectedProducts),
          );
        } catch (storageError) {
          console.error('Error storing unselected products:', storageError);
        }
      }

      const res = await Cart.applyVoucherRequest(payload);
      if (res.status === 200) {
        return res.data.data;
      }
    } catch (err) {
      return err?.response?.data;
    }
  },
);

export const cancelVoucher = createAsyncThunk(
  RESET_VOUCHER,
  async (payload) => {
    try {
      const res = await Cart.cancelVoucherRequest(payload);
      if (res.status === 200) {
        return res.data.success;
      }
    } catch (err) {
      return err.response.data;
    }
  },
);

export const getVouchers = (payload) => {
  return async () => {
    try {
      const res = await Cart.vouchersRequest(payload);
      if (res.status === 200) {
        return res.data.data;
      }
    } catch (err) {
      return err.response.data;
    }
  };
};

export const getVouchersCount = (params) => {
  return async () => {
    try {
      const res = await Cart.vouchersCountRequest(params);
      if (res.status === 200) {
        return res.data.data;
      }
    } catch (err) {
      return err.response.data;
    }
  };
};

export const getCategoryVouchers = createAsyncThunk(
  'cart/categoryVouchers',
  async (id) => {
    try {
      const res = await Cart.getVouchersByCategoryIdRequest(id, {
        fields:
          '_id name discount_type free_products_type voucher_info image to_date code',
        sort: '-created_at',
      });
      return res.data.data;
    } catch (err) {
      return err.response.data;
    }
  },
);

export const setSelectVoucher = (payload) => {
  return async (dispatch) => {
    dispatch({ type: SET_SELECT_VOUCHER, payload });
  };
};
